export default "__VITE_ASSET__D0vToBa6__"